/* ============================================================================
 * dh-pdp.js
 * Dreadfull Hippie PDP pack-count presets. Loaded only on product pages by
 * sections/product.liquid. Uses event delegation so it survives the theme's
 * Alpine/morph re-renders on variant change.
 *
 * Behavior: when a .dh-preset radio (name="dh_pack_preset") changes, set the
 * product form's quantity input to the preset's data-qty and fire input+change
 * so Pipeline's x-stepper / Alpine quantity state and the ATC price update.
 * The radios are intentionally outside the <form> (no form= attr), so they are
 * never submitted as a line-item property.
 * ========================================================================== */
(function () {
  'use strict';

  function setQuantity(input, value) {
    if (!input) return;
    input.value = value;
    // Pipeline binds quantity via Alpine x-stepper:input; bubble both events.
    input.dispatchEvent(new Event('input', { bubbles: true }));
    input.dispatchEvent(new Event('change', { bubbles: true }));
  }

  function findQuantityInput(fromEl) {
    var scope = fromEl.closest('[data-section-type="product"]') ||
                fromEl.closest('.product-page') ||
                document;
    return scope.querySelector('input[name="quantity"]');
  }

  document.addEventListener('change', function (e) {
    var radio = e.target;
    if (!radio || radio.name !== 'dh_pack_preset') return;

    var preset = radio.getAttribute('data-qty');
    if (preset) setQuantity(findQuantityInput(radio), preset);
  });

  // Reverse sync: if the shopper edits the quantity directly (typing or the theme +/- stepper),
  // keep the highlighted preset honest: select the matching preset, or clear all presets.
  document.addEventListener('input', function (e) {
    var input = e.target;
    if (!input || input.name !== 'quantity') return;
    var scope = input.closest('[data-section-type="product"]') || input.closest('.product-page');
    if (!scope) return;
    var radios = scope.querySelectorAll('input[name="dh_pack_preset"]');
    if (!radios.length) return;
    var val = String(parseInt(input.value, 10) || '');
    var matched = null;
    radios.forEach(function (r) {
      var q = r.getAttribute('data-qty');
      if (q === val) matched = r;
    });
    radios.forEach(function (r) {
      r.checked = r === matched;
    });
  });

  // Initial sync (PDP Confidence Pass): on load, set the quantity to the
  // default-checked preset so the mobile default reflects a real pack count
  // (Half head = 4 packs), never a lone "1 pack". Idempotent; a short retry
  // catches the theme's Alpine x-stepper initialising after first paint.
  // A genuine (isTrusted) user interaction with the quantity or a preset
  // cancels the init/retry, so we never overwrite a choice the shopper made
  // before the 400ms retry fires. Programmatic events (isTrusted=false) from
  // setQuantity do not trip this guard.
  var dhUserTouched = false;
  ['pointerdown', 'keydown', 'input', 'change'].forEach(function (evt) {
    document.addEventListener(evt, function (e) {
      if (!e.isTrusted) return;
      var t = e.target;
      if (t && (t.name === 'quantity' || t.name === 'dh_pack_preset')) dhUserTouched = true;
    }, true);
  });

  function initFromDefault() {
    // A/B: only the treatment opens the buy box at the Half-head default. Control
    // (and any un-bucketed/no-JS state) keeps the theme's native 1-pack default.
    if (!document.documentElement.classList.contains('dh-cp-t')) return;
    if (dhUserTouched) return;
    var checked = document.querySelector('input[name="dh_pack_preset"]:checked');
    if (!checked) return;
    var q = checked.getAttribute('data-qty');
    if (!q) return;
    var qtyInput = findQuantityInput(checked);
    if (!qtyInput) return;
    if (String(parseInt(qtyInput.value, 10) || 1) !== String(q)) setQuantity(qtyInput, q);
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initFromDefault);
  } else {
    initFromDefault();
  }
  setTimeout(initFromDefault, 400);
})();

/* ============================================================================
 * Mobile sticky Add-to-Cart bar (.dh-stickybar in sections/product.liquid).
 * Shows once the real buy buttons scroll above the viewport; the bar's button
 * proxies a click to the theme's [data-add-to-cart] so Alpine/cart-drawer
 * behavior is identical. Price is mirrored from the rendered price element
 * (event + interval fallback survives morph re-renders on variant change).
 * ========================================================================== */
(function () {
  'use strict';

  function init() {
    var bar = document.querySelector('[data-dh-stickybar]');
    if (!bar) return;
    var section = document.querySelector('[data-section-type="product"]');
    if (!section) return;

    var priceOut = bar.querySelector('[data-dh-sticky-price]');
    var sezzleOut = bar.querySelector('[data-dh-sticky-sezzle]');

    function findAtc() { return section.querySelector('[data-add-to-cart]'); }
    function findPriceEl() {
      return section.querySelector('[data-product-price]') ||
             section.querySelector('.product__price') ||
             section.querySelector('.product__block__price .price') ||
             section.querySelector('.price');
    }

    function mirrorPrice() {
      var el = findPriceEl();
      if (!el || !priceOut) return;
      var txt = (el.textContent || '').trim().replace(/\s+/g, ' ');
      if (!txt) return;
      if (priceOut.textContent !== txt) priceOut.textContent = txt;
      if (sezzleOut) {
        var m = txt.replace(/,/g, '').match(/\$ ?([0-9]+(?:\.[0-9]{1,2})?)/);
        if (m) sezzleOut.textContent = 'or 5 Sezzle payments of $' + (parseFloat(m[1]) / 5).toFixed(2);
      }
    }
    mirrorPrice();
    setInterval(mirrorPrice, 1000);
    document.addEventListener('change', mirrorPrice);

    var atc = findAtc();
    if (atc && 'IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (entries) {
        var e = entries[0];
        var passed = !e.isIntersecting && e.boundingClientRect.top < 0;
        bar.classList.toggle('on', passed);
      }, { threshold: 0 });
      io.observe(atc);
    }

    var proxy = bar.querySelector('[data-dh-sticky-atc]');
    if (proxy) {
      proxy.addEventListener('click', function () {
        var btn = findAtc();
        if (btn) btn.click();
      });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();


/* DH (Oct 2026): after Add to Cart, open the slide-out cart (free-shipping
   progress + trust line) instead of the small header "added to cart" popdown. */
(function () {
  if (window.__dhDrawer) return; /* handled site-wide in layout/theme.liquid */ document.head.insertAdjacentHTML('beforeend', '<style>.product-add-popdown{display:none!important}</style>');
  document.addEventListener('theme:cart:popdown', function () {
    var drawer = document.getElementById('drawer-cart');
    if (!drawer) return;
    document.dispatchEvent(new CustomEvent('theme:cart:reload', { bubbles: true }));
    setTimeout(function () {
      drawer.dispatchEvent(new CustomEvent('theme:drawer:open', { bubbles: false }));
    }, 50);
  });
})();
